import { Modal } from "antd"
import { getResource } from "../../helpers/ResourcesHelper"
import Button from "../inputs/Button"

const BankInterfaceModalMessage = (props: any) => {
  return <Modal
    title={
      <h3 className="component-title">{props.title}</h3>}
    centered
    open={props.open}
    footer={null}
    onCancel={props.onCancel}
    className="modal-message-auto"
    zIndex={1020}
  >
    <div>
      {props.message}
    </div>

    <div className="row-actions">
      <Button
        type={"primary"}
        onClick={props.ok}
      >{getResource('Button.Ok')}</Button>
    </div>
  </Modal>
}

export default BankInterfaceModalMessage